import { getContext, setContext } from 'svelte';

import type { AppServices } from './services.svelte';

/** Exported so component tests can provide services via `render(…, { context })`. */
export const SERVICES_KEY = Symbol('kinklist-services');

export function setServices(services: AppServices): AppServices {
  return setContext(SERVICES_KEY, services);
}

export function getServices(): AppServices {
  const services = getContext<AppServices | undefined>(SERVICES_KEY);
  if (!services) throw new Error('getServices() called outside the app');
  return services;
}
